export const intentUserApprovalModalConfig = {
    content: {
        width: "641px",
        padding: "44px 68px",
    },
    overlay: {
        zIndex: 110,
    },
};
